import React from "react";
import { observer } from "mobx-react";
import { EditionTypeUpdateStore } from "../../store";
import { EditionTypeUpdateForm } from "./EditionTypeUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type EditionTypeUpdateProps = {
  editionTypeUpdateStore: EditionTypeUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const EditionTypeUpdate: React.FC<EditionTypeUpdateProps> = observer(
  ({ editionTypeUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={editionTypeUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={editionTypeUpdateStore.savedButOutdated}
          onReload={() => editionTypeUpdateStore.reloadEditionType()}
          reloadDisabled={editionTypeUpdateStore.isProcessing}
        />
        <EditionTypeUpdateForm
          editionTypeUpdateStore={editionTypeUpdateStore}
          name_esError={editionTypeUpdateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            editionTypeUpdateStore.setName_esValue(value);
          }}
          name_es={editionTypeUpdateStore.entityValues.name_es}
          name_enError={editionTypeUpdateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            editionTypeUpdateStore.setName_enValue(value);
          }}
          name_en={editionTypeUpdateStore.entityValues.name_en}
          name_ptError={editionTypeUpdateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            editionTypeUpdateStore.setName_ptValue(value);
          }}
          name_pt={editionTypeUpdateStore.entityValues.name_pt}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={editionTypeUpdateStore.saveDisabled}
          onSave={() => editionTypeUpdateStore.saveEditionType()}
          onCancel={() => editionTypeUpdateStore.cancelEditionType()}
        />
        <ErrorDialog
          open={editionTypeUpdateStore.errorDialogOpened}
          title={editionTypeUpdateStore.errorTitle}
          description={editionTypeUpdateStore.errorDescription}
          onClose={() => editionTypeUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={editionTypeUpdateStore.confirmDialogOpened}
          title={editionTypeUpdateStore.confirmDialogTitle}
          description={editionTypeUpdateStore.confirmDialogDescription}
          onConfirm={() => editionTypeUpdateStore.executeConfirmedAction()}
          onCancel={() => editionTypeUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
